angular.module('SpidApp')

.filter('ordersByStatus',['_', function (_) {
    return function (ordersArray, filterArray) {
    	return _.chain(ordersArray).filter(function(order) {
    		 return _.find(filterArray, function(filter) {
     	    	return filter.checked  && filter.id === order.lastStatus.status;
 	    	})
    	}).value();
    }
}])



